(function main(): void {
  const newScript: HTMLScriptElement = document.createElement('script');
  const lastScript: HTMLScriptElement | undefined = document.getElementsByTagName('script')?.[0];
  if (lastScript?.parentNode) {
    lastScript.parentNode.insertBefore(newScript, lastScript);
  }
  newScript.type = 'text/javascript';
  newScript.async = true;
  newScript.src = `//js.hs-scripts.com/${process.env.HUBSPOT_TRACKING_ID}.js`;
})();
